import React from 'react';
import PropTypes from 'prop-types';
import css from './CircularProgressBar.css';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';

function CircularProgressBar({
    size = 72,
    progressPercentage,
    strokeWidth = '6px',
    containerColor = 'var(--gray300)',
    strokeColor = 'var(--blue300)',
    iconName = '',
    iconSize = IconSizes.LARGE,
    iconVariant = IconVariants.DARK,
}) {
    const dynamicCSSVariables = {
        '--size': `${size}px`,
        '--stroke-width': strokeWidth,
        '--container-color': containerColor,
        '--stroke-color': strokeColor,
        '--progress': progressPercentage,
    };

    return (
        <div className={css.circularProgressContainer} style={dynamicCSSVariables}>
            {iconName && (
                <Icon name={iconName} size={iconSize} variant={iconVariant} className={css.icon} interactive={false} />
            )}
            <svg className={css.circularProgress} width={size} height={size}>
                <circle className={css.bg} />
                <circle className={css.fg} />
            </svg>
        </div>
    );
}

CircularProgressBar.propTypes = {
    progressPercentage: PropTypes.number.isRequired,
    containerColor: PropTypes.string,
    strokeColor: PropTypes.string,
    strokeWidth: PropTypes.string,
    iconName: PropTypes.string,
    iconSize: PropTypes.string,
    iconVariant: PropTypes.string,
    size: PropTypes.number,
};

export default CircularProgressBar;
